import { peopleTypes } from '@/reports/types';
import { formatJob } from '@/utils/index';

function filterAdditionalTitles(additional_titles: peopleTypes.Titles) {
  return additional_titles.filter((title) => {
    return title.name;
  });
}

/**
 * Formats a job title string to be titleized, with uppercase exceptions for common acronyms
 * and lowercase execeptions for articles/conjunctions/prepositions
 * @param job A Job object
 * @param fallbackText A string to return if the job title is not found
 * @returns A titleized job title string, with uppercase exceptions for common acronyms
 * and lowercase execeptions for articles/conjunctions/prepositions
 */
export function fetchJobTitle(job: peopleTypes.Job, fallbackText = '-') {
  if (job?.title) {
    return formatJob(job.title);
  }

  if (job?.additional_titles) {
    const additionalTitles = filterAdditionalTitles(job.additional_titles);
    return formatJob(additionalTitles?.[0]?.name || '') || fallbackText;
  }

  return fallbackText;
}
